<template>
    <div>
        <h1 class="display-heading">Forgot Password</h1>

        <form @submit.prevent="submitForgotPassword">
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group required">
                        <label>Email Address</label>

                        <input type="text" name="email" ref="email" data-vv-validate-on="blur"
                            placeholder="Enter your email address" v-model="form.emailAddress" v-validate="'required|email'"
                            :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('email')
                            }">

                        <div v-show="validationErrors.has('email')" class="invalid-feedback">
                            {{ validationErrors.first('email') }}
                        </div>
                    </div>
                </div>
            </div>

            <popup-modal ref="popupModalConfirmation" :hasCloseButton="false" title="Reset Password">
                <template slot="content">
                    <p>{{resetPasswordMessage}}</p>

                </template>
                <template slot="footer">
                    <button v-if="resetSuccess" type="button" class="btn btn-primary btn-primary-insv" @click="backToLogin">Okay</button>
                    <button v-else type="button" class="btn btn-primary btn-primary-insv" @click="dismissPopup">
                        Okay
                    </button>
                </template>
            </popup-modal>

            <button @click="submitForgotPassword" class="btn btn-primary btn-primary-insv mr-2" type="button">Reset My Password</button>
            <router-link class="btn btn-secondary" :to="{'name': 'login'}">Back to Login</router-link>
        </form>
    </div>

</template>

<script>
import popupModal from '@/components/popup-modal';
export default {
    'name': 'ForgotPassword',
    'components': {
        popupModal
    },
    data () {
        return {
            'form': {
                'emailAddress': ''
            },
            'resetPasswordMessage': '',
            'resetSuccess': false
        };
    },
    'methods': {
        submitForgotPassword () {
            this.$validator.validateAll().then((isValid) => {
                if (isValid) {
                    // create reset password request in DB
                    this.axios.post('Account/RequestResetPassword', {
                        'emailAddress': this.form.emailAddress
                    }).then(() => {
                        this.resetSuccess = true;
                        this.resetPasswordMessage = 'Your request has been processed. Please check your e-mail for the instructions to reset your password.';
                        this.$refs.popupModalConfirmation.show();
                    }).catch(() => {
                        this.resetPasswordMessage = 'Error submitting reset password request. Please try again.';
                        this.$refs.popupModalConfirmation.show();
                    });
                }
            });
        },
        backToLogin () {
            this.$refs.popupModalConfirmation.hide().then(() => {
                this.$router.push({ 'name': 'login' });
            });
        },
        dismissPopup () {
            this.$refs.popupModalConfirmation.hide();
        }
    }
};

</script>

<style>

</style>
